export const widthFromString = ({
    strA,
    strB,
    minWidth = 100,
    defaultWidth = 'fit-content'
}: {
    strA: string | string[]
    strB: string | string[]
    minWidth?: number
    defaultWidth?: string
}): string => {
    if (!strA || !strA?.length || !strB || !strB?.length) return defaultWidth

    let a = strA as string
    let b = strB as string

    const letterWidth = 8 // average width of a character in pixels, this is an approximation and can vary based on the actual characters and font used
    const padding = 32 // total horizontal padding in pixels (16px on each side)

    if (typeof strA !== 'string') {
        a = getStringWithMaxLengthFromList(strA)
    }
    if (typeof strB !== 'string') {
        b = getStringWithMaxLengthFromList(strB)
    }

    const itemOptionWithMaxLength = Math.max(a?.length || 0, b?.length || 0)

    if (itemOptionWithMaxLength > 0) {
        const newWidth = letterWidth * itemOptionWithMaxLength + padding

        return newWidth > minWidth ? `${newWidth}px` : `${minWidth}px`
    }

    return defaultWidth
}

export function getStringWithMaxLengthFromList(list: string[]): string {
    return list.reduce((max, current) => (current?.length > max?.length ? current : max), '')
}
